module.exports = __webpack_public_path__ + "static/htmlvalidation-41f1e08abea269e3879850ca7eaee806.png";